const initState = {
    status: '',
    error: null,
}

const dirReducer = (state = initState, action) => {

    switch (action.type) {
        case 'DIR_CREATE_PENDING':     return { ...state, status: action.type, error: null }
        case 'DIR_CREATE_ERROR':       return { ...state, status: action.type, error: action.payload }
        case 'DIR_CREATE_SUCCESS':     return { ...state, status: action.type, error: null }

        case 'DIR_RENAME_PENDING':     return { ...state, status: action.type, error: null }
        case 'DIR_RENAME_ERROR':       return { ...state, status: action.type, error: action.payload }
        case 'DIR_RENAME_SUCCESS':     return { ...state, status: action.type, error: null }

        case 'DIR_DELETE_PENDING':     return { ...state, status: action.type, error: null }
        case 'DIR_DELETE_ERROR':       return { ...state, status: action.type, error: action.payload }
        case 'DIR_DELETE_SUCCESS':     return { ...state, status: action.type, error: null }

        default: return state;
    }
};

export default dirReducer;